module.exports = __webpack_public_path__ + "static/media/person.fc237b87.svg";